import apiClient from './AxiosHttp'

const login = (details) => {
    return apiClient.post(`/auth/token/`, details)
}

const getUser = () => {
    return apiClient.get('/users/user/')
}

const getCategories = () => {
    return apiClient.get('/houses/categories/')
}

const getAmenities = ()=> {
    return apiClient.get('/houses/amenities/')
}

const getProperties = (params) => {
    return apiClient.get(`/houses/properties/${params}`)
}

const getPropertyDetails = (slug) => {
    return apiClient.get(`/houses/property/${slug}/`)
}

const authServices = {
    login,
    getUser,
    getCategories,
    getAmenities,
    getProperties,
    getPropertyDetails,
}

export default authServices